import { render } from "./addEmoji.vue?vue&type=template&id=bb55f36c"
import script from "./addEmoji.vue?vue&type=script&lang=js"
export * from "./addEmoji.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__